import { AttributeValue } from 'app/components/attributes/attributes.model';
import { Entity } from 'app/pages/product/product.model';


export class User extends Entity
{
    
    initials: string;
    login: string;
    password: string;
    mail: string;
    workingHoursPerDay: number;
    hourIncome: number;
    description: string;
    enabled: boolean;
    external: boolean;
    externalId: number;
    creationDate: Date;
    disablingDate: Date;
    enableRecordingHours: boolean;
    attributes: AttributeValue[];
    roles: Entity[];
    teams: Entity[];

    
    

    /**
     * Constructor
     *
     * @param user
     */
    constructor(user?)
    {
        user = user || {};
        super(user);
        
        this.initials = user.initials;
        this.login = user.login;
        this.password = user.password;
        this.mail = user.mail;
        this.workingHoursPerDay = user.workingHoursPerDay;
        this.hourIncome = user.hourIncome;
        this.description = user.description;
        this.enabled = user.enabled !== undefined ? user.enabled : this.enabled;
        this.external = user.external !== undefined ? user.external : false;
        this.externalId = user.externalId;
        // this.createdBy= user.createdBy;
        this.creationDate = user.creationDate;
        this.disablingDate = user.disablingDate;
        this.attributes = user.attributes;
        this.enableRecordingHours = user.enableRecordingHours !== undefined ? user.enableRecordingHours : false;
        this.roles = user.roles || [];
        this.teams = user.teams || [];
    }

}
